const isZeroOrNull = (num) => {
    return !num || Number(num) === 0;
}

const numberUtils = {
    isZeroOrNull
}

export default numberUtils;